var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-11 race-comments mt-2",domProps:{"innerHTML":_vm._s(this.$options.filters.boldname(_vm.raceComments))}})
}
var staticRenderFns = []

export { render, staticRenderFns }